import { useEffect, useMemo, useState } from 'react'

import { WizardData } from 'modules/employees/components/UnifiedAddEmployeeModal/types'
import { Salary } from 'modules/job_catalog/lib/salary'
import { getRecommendedSalaryValue } from 'modules/job_catalog/lib/salaryUtils'

export const usePrefillSalaryInitialValue = (
  data: WizardData,
  onSalaryChange: (value: string, frequency?: string) => void,
  salaryRange?: Salary | undefined
) => {
  const [initialValue, setInitialValue] = useState<number>()

  const recommendedSalaryValue = useMemo(() => {
    if (!salaryRange) return
    return getRecommendedSalaryValue(salaryRange)
  }, [salaryRange])

  useEffect(() => {
    if (!recommendedSalaryValue) return

    setInitialValue(recommendedSalaryValue)

    const hasValueOrHasBeenSetAlready = !!(
      data.salaryAmount ||
      (initialValue === recommendedSalaryValue && data.salaryAmount !== undefined)
    )
    if (hasValueOrHasBeenSetAlready) return
    onSalaryChange(`${recommendedSalaryValue}`, salaryRange?.periodicity)
  }, [
    onSalaryChange,
    initialValue,
    setInitialValue,
    data,
    recommendedSalaryValue,
    salaryRange?.periodicity,
  ])

  return initialValue
}
